/**
 * Created by rathompson on 1/5/24
 * File: ConnectedTableDownloadButton.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */


import type { ReactNode, VFC } from 'react'
import { downloadCSV, useTableInstance } from '@panwds/react-table'
import TooltipButton from '../tooltipButton/TooltipButton'
import { DownloadIcon } from '@panwds/icons'
import type { ButtonAppearances } from '@panwds/react-ui'
import React from 'react'

const ConnectedTableDownloadButton: VFC<{
  fileName: (() => string) | string,
  addClassName?: string,
  appearance?: ButtonAppearances,
  icon?: ReactNode,
  children?: any,
  label?: string
}> = ({
  children,
  fileName,
  addClassName = '',
  appearance = 'secondary',
  icon = <DownloadIcon size="md" />,
  label = 'Download the current table data'
}) => {

  const tableInstance = useTableInstance()
  const disabled = tableInstance.rows.length === 0
  const ariaLabel = 'Download'

  return (
    <TooltipButton
      label={label}
      aria-label={ariaLabel}
      disabled={disabled}
      buttonProps={{
        'aria-label': ariaLabel,
        appearance,
        icon,
        addClassName,
        onClick: () => {
          const fn = typeof fileName === 'function' ? fileName() : fileName
          downloadCSV(tableInstance, fn)
        }
      }}
    >{children}</TooltipButton>
  )
}

export default ConnectedTableDownloadButton
